// Connection type
// const pageServidor = 'http://localhost/React_JS/chroma_predios/dashboard/public/';
const pageServidor  = '.';
export const connectionPage = pageServidor;

// Cookies type
//const cookiesServidor        = './';
const cookiesServidor         = 'bees.project.chroma-garden.com/';
export const cookiesRegister  = cookiesServidor;

// Cookies name
export const typeCookie       = 'bees_project';
export const typeCookieType   = 'bees_project_type';
export const typeCookiePassw  = 'bees_project_passw';
export const typeCookieEmail  = 'bees_project_email';

export const typeCookiePage   = 'bees_project_page';
export const typeCookiePageId = 'bees_project_page_id';

// opt box editor
export const config = {
    zIndex: 0,
    readonly: false,
    width: 'auto',
    height: 'auto',
    minHeight: 100,
    direction: '',
    language: 'auto',
    tabIndex: -1,
    buttons: ['bold', 'italic', 'underline', 'link', 'ul', 'ol', 'source'],
    link: {
        modeClassName: false,
        noFollowCheckbox: false,
        openInNewTabCheckbox: false,
        processPastedLink: false,
        processVideoLink: false,
        selectMultipleClassName: false,
        selectOptionsClassName: false,
    },
    imageDefaultWidth: 24,
    image: {
        dialogWidth: true,
        editAlign: false,
        editAlt: false,
        editBorderRadius: true,
        editClass: false,
        editId: false,
        editLink: true,
        editMargins: false,
        editSize: true,
        editSrc: true,
        editStyle: false,
        editTitle: false,
        openOnDblClick: true,
        selectImageAfterClose: true,
        showPreview: true,
        useImageEditor: true,
    },
    placeholder: "Digite o texto aqui...",
    toolbarAdaptive: false
}